import(/* webpackMode: "eager" */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/error.tsx");
